import React from 'react';
import { AppContext } from './AppStore';

export function useStore() {
  return React.useContext(AppContext);
}
